export default {
      id: "Icon--plus-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--plus",
      toString: function () {
        return this.url;
      }
    }